// extracted by mini-css-extract-plugin
export default {"separator":"MenuItemSeparator-separator-umWCF"};